<mat-card appearance="outlined" class="card">
  <div class="flex-row">
    <div class="fxflex-1-0" style="flex-basis: 15%">
      <button
        matButton="elevated"
        color="primary"
        (click)="createSeqForm()"
        class="app-panel-button"
        i18n
        [disabled]="editMode === true"
      >
        Create New Seq. Act
      </button>
      <button
        matButton="elevated"
        color="primary"
        (click)="editSeqForm()"
        class="app-panel-button"
        i18n
        [disabled]="editMode === false"
      >
        Edit Existing Seq. Act
      </button>
      @if (editMode) {
      <div>
        <mat-select
          class="app-panel-button"
          (selectionChange)="getFormId($event.value)"
          [disabled]="editing === true"
          placeholder="Select action"
          i18n-placeholder
        >
          @for (templ of loadedSeqForms$ | async; track templ; let i = $index) {
          <mat-option [value]="i">{{ templ.name }}</mat-option>
          }
        </mat-select>
        <button
          matButton="filled"
          color="accent"
          (click)="loadForm(formId)"
          class="app-panel-button"
          [disabled]="formId === null"
          i18n
        >
          Load Seq. Action
        </button>
      </div>
      }
      <button
        matButton="elevated"
        (click)="clearRefresh()"
        class="app-panel-button"
        i18n
        [disabled]="editMode === null"
      >
        Clear and Refresh
      </button>
      <button
        matButton="elevated"
        color="accent"
        type="submit"
        (click)="saveSeqAction()"
        class="app-panel-button"
        i18n
        [disabled]="form.invalid || form.pristine"
      >
        Save Seq. Action
      </button>
    </div>
    @if (editMode !== null) {
    <div class="fxflex-1-0" style="flex-basis: 65%">
      <form [formGroup]="form">
        <mat-card-title>
          <mat-form-field style="padding-right: 6em; width: 20em">
            <mat-label i18n>Action Name</mat-label>
            <input matInput formControlName="name" />
          </mat-form-field>
        </mat-card-title>
        <mat-card-content>
          <div>
            <mat-form-field style="margin-right: 2em">
              <mat-label i18n>Pdf tag</mat-label>
              <input matInput formControlName="renderTag" />
            </mat-form-field>
            <mat-checkbox
              style="margin-right: 2em"
              formControlName="signatureRequired"
              i18n
            >
              Signature Required
            </mat-checkbox>
            <button
              matButton="filled"
              color="primary"
              (click)="addField()"
              i18n
            >
              Add Field
            </button>
          </div>
          <div formArrayName="fields">
            @if ( getFormArray(form.controls.fields).length) {
            <div class="flex-row left-center">
              @for (item of getFormArray(form.controls.fields).controls; track
              item; let i = $index) {
              <div class="app-column">
                <app-table-field [index]="i"
                  [itemForm]="getFormGroup(item)"
                  (deleteItem)="deleteField($event)"
                 />
              </div>
              }
            </div>
            }
          </div>
        </mat-card-content>
      </form>
    </div>
    } @else {
    <div class="fxflex-1-0" style="flex-basis: 65%">
      <h2 i18n>
        Create new sequential order action or select existing one, edit it and
        save as a new action
      </h2>
    </div>
    }
  </div>
</mat-card>
